import { Response } from './index';
import { mgmtAxios, MgmtEnvelope } from './mgmt';
import { AxiosError } from 'axios';

export interface MeRes {
  data: MeData;
}

export interface MeData {
  id: number;
  brand_id: number;
  realname: string;
  nickname: string;
  mobile_number: string;
  created_at: string | null;
  updated_at: string | null; // 22.10.24 SCH
  line_id: string | null;
  birthday: string | null;
  email: string | null;
  line_pay: number; // 22.10.19 SCH
  user_role: number; // 22.11.23 SCH
  user_type: string | null; // 22.11.23 SCH
  regkey: string | null;
  regkey_expire_at: string | null;
  pay_amount: number; // 逾期14天扣款50元
  common: number;     // [1:一般會員, 0:正式會員]
  photo_url?: string; // 22.07.07 SCH
  photo_img?: [
    {
      originFileObj?: Blob;
      uid: number;
      url: string;
      status: string;
      name?: string;
    },
  ];
}
/**
 * 會員自身資料
 * @param token token
 */
export const getMe = async (token: string): Promise<Response<MeData>> => {
    // PG-55 改讀新後端 profile;新後端無「會員等級/line_pay/生日」等欄位,給預設
    const { data } = await mgmtAxios.request<MgmtEnvelope<{
      id: number;
      mobile_number: string | null;
      realname: string | null;
      nickname: string | null;
      email: string | null;
      line_id: string | null;
      birthday: string | null;
      photo_url: string | null;
      created_at: string | null;
      updated_at: string | null;
    }>>({
      url: `/api/member/profile`,
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    });
    const p = data.details;
    return {
      data: {
        id: p.id,
        brand_id: 0,
        realname: p.realname ?? '',
        nickname: p.nickname ?? '',
        mobile_number: p.mobile_number ?? '',
        created_at: p.created_at,
        updated_at: p.updated_at,
        line_id: p.line_id,
        birthday: p.birthday,
        email: p.email,
        line_pay: 0,
        user_role: 0,
        user_type: null,
        regkey: null,
        regkey_expire_at: null,
        pay_amount: 0,
        common: 1,
        photo_url: p.photo_url ?? undefined,
      },
    };
};

interface ModifyResponse<T> {
  error?: AxiosError<{ message: string; errors: { [key: string]: string } }>;
  data?: T;
}

export const modifyMe = async (
    token: string,
    formData: FormData,  // formData: Partial<MeData>, // 22.07.11 SCH
): Promise<ModifyResponse<{ data: {
  data: any; message: string, photo_url: string
} }>> => {
    // PG-55 改打新後端 PATCH profile。新後端吃 JSON(非 multipart),故從 FormData
    // 抽出文字欄位轉 JSON;頭像上傳新後端沒有對應,暫略(不影響文字更新)。
    const body: Record<string, unknown> = {};
    ['realname', 'nickname', 'email', 'birthday', 'gender'].forEach((k) => {
      const v = formData.get(k);
      if (v !== null && v !== undefined && v !== '') body[k] = v;
    });
    try {
      const { data } = await mgmtAxios.request<MgmtEnvelope<any>>({
        url: `/api/member/profile`,
        method: 'PATCH',
        data: body,
        headers: { Authorization: `Bearer ${token}` },
      });
      // profile.tsx 是照舊版的 'Successfully updated.' 判斷成功,這裡維持同一個字串,
      // 否則每次更新成功都會被當失敗顯示「更新失敗,請重試」。
      return { data: { data: { data: data.details, message: 'Successfully updated.', photo_url: data.details?.photo_url ?? '' } } };
    } catch (error: any) {
      return { error };
    }
};
